import { render, staticRenderFns } from "./NewEditHistoricoPage.vue?vue&type=template&id=6c84171a"
import script from "./NewEditHistoricoPage.vue?vue&type=script&lang=js"
export * from "./NewEditHistoricoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports